// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 5634 ? "fullscreenGallery" : chunkId) + ".js?id=" + {"1543":"1816803b22b4ab63","1702":"db45f6a43899ce8c","4724":"af8d32d833063e92","5634":"9b8a0b0731aa1289"}[chunkId] + "";
};